module.exports = __webpack_public_path__ + "static/media/da-about-4.aaf1002d.jpg";